export const en = {
    AuthenticatedLayout: {
        title: "Workleap",
        agent: "Agent",
        jumpTo: "Jump to",
        openNavigation: "Open navigation",
        closeNavigation: "Close navigation",
        primaryNavigation: "Primary",
        openUserMenu: "Open workspace and user menu",
        viewProfile: "View profile",
        settings: "Settings",
        workspace: "Workspace",
        currentWorkspace: "Current workspace",
        switchWorkspaceError: "Couldn't switch workspace. Please try again.",
        loadingWorkspaces: "Loading workspaces",
        switchingWorkspace: "Switching workspace",
        logout: "Log out",
        resizeAgentPanel: "Resize agent panel"
    },
    CreateMenu: {
        create: "Create",
        newSurvey: "New survey",
        newReviewCycle: "New review cycle"
    },
    SidebarLayout: {
        navigation: "Sections",
        closeMenu: "Close menu"
    },
    TabsLayout: {
        tabs: "Tabs"
    },
    PageTitleHeading: {
        openMenu: "Open menu"
    },
    ModuleErrorBoundary: {
        title: "Something went wrong",
        description: "We couldn't load this page. You can try again, or head back home.",
        retry: "Try again",
        goHome: "Go home"
    },
    NotFoundPage: {
        title: "Page not found",
        code: "404",
        description: "This page could not be found.",
        backHome: "Back to home"
    },
    OrganizationAccessPage: {
        title: "Not available",
        heading: "Not available for your organization yet",
        body: "Your organization doesn't have access to the new Workleap experience. You can keep using the classic Workleap experience.",
        backToWorkleap: "Back to Workleap"
    },
    RootErrorBoundary: {
        title: "Something went wrong",
        description: "The application could not start. Try refreshing the page or returning to the home page.",
        goHome: "Go home"
    },
    BootstrappingRoute: {
        loading: "Loading"
    },
    unmanagedMutationErrors: {
        toastMessage: "Something went wrong. Please try again."
    },
    CommandMenu: {
        placeholder: "Jump to",
        noResults: "No results match your search.",
        searching: "Searching...",
        dialogLabel: "Command palette",
        sections: {
            people: "People",
            teams: "Teams"
        },
        memberCount_one: "{{count}} member",
        memberCount_other: "{{count}} members",
        footer: {
            navigate: "navigate",
            open: "open",
            escToClose: "esc to close"
        }
    }
};
